import {
  getCurrentHsaGroupInput,
  getCurrentHsaGroupOutput,
} from "@redotech/redo-conversion-hsa-common/rpc-schemas/get-current-hsa-group";
import { unaryRpc } from "@redotech/rpc/definition";

// First call on portal page load. Returns the current state plus
// session-level data the client needs to render its chrome (order summary,
// completion redirect). Reload-resume comes from the server walking the
// flow against the stored answer set every time — no client cursor.
export const getCurrentHsaGroup = unaryRpc({
  name: "getCurrentHsaGroup",
  input: getCurrentHsaGroupInput,
  output: getCurrentHsaGroupOutput,
});
